<template>
  <div class="part1-wrap">
    <v-nav class="nav" :url="'static/img/logo.png'" :color="'white'" :showIndex="showIndex"
           :changeMethods="true"></v-nav>
    <div class="main-con">
      <p class="letter">国内较早的区块链平台提供商<br>
        专注于区块链底层核心技术研究与生态建设</p>
      <h1>跨越创新&nbsp;·&nbsp;链接世界</h1>
      <h3>Cross innovation and link the world</h3>
      <p>The earliest block chain platform provider in China.<br/>
        Focus on core technology research and ecological construction at the bottom of block chain</p>
    </div>
    <div class="img">
      <transition name="fade">
        <img ref="arrow" v-show="flag" @load="scale" src="../../assets/img/head-arrow.png"/>
      </transition>
    </div>
  </div>
</template>

<script>
  import VNav from "../plug/Nav";

  export default {
    props: ['animation', 'showIndex'],
    data() {
      return {
        flag: false,
        loadFlag: false,
        firstLoad: true
      }
    },
    components: {VNav},
    name: "part1",
    mounted() {
      this.firstLoad = false;
      let that = this;
      setTimeout(function () {
        that.scale();
      }, 500)
    },
    methods: {
      scale() {
        this.flag = this.animation;
        this.loadFlag = true;
      }
    },
    watch: {
      animation: function (val) {
        if (this.loadFlag && !this.firstLoad) {
          let that = this;
          setTimeout(function () {
            that.flag = val;
          }, 500)
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .part1-wrap {
    position: relative;
    box-sizing: border-box;
    height: 100%;
    background: url("../../assets/img/head-bg.jpg");
    background-size: 100% 100%;
    .nav {
      position: relative;
      z-index: 10;
    }
    .main-con {
      width: 80%;
      position: absolute;
      /*top: calc(~'50% - 187px');*/
      /*left: calc(~'50% - 573px');*/
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      p {
        font-size: 1.6rem;
        color: white;
        text-align: center;
        &:last-of-type {
          font-size: 1.38rem;
          color: rgba(255, 255, 255, .5);
        }
      }
      .letter {
        letter-spacing: .25rem;
      }
      h1 {
        width: 80%;
        padding: 28px 0;
        line-height: 80px;
        margin: auto;
        text-align: center;
        color: white;
        font-size: 6rem;
        letter-spacing: 10px;
        border-bottom: 1px solid rgba(255, 255, 255, .4);
      }
      h3 {
        margin: 28px 0;
        text-align: center;
        color: white;
        font-size: 2rem;
        line-height: 28px;
      }
    }
    .img {
      position: absolute;
      width: 80%;
      height: 85%;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -48%);
    }
    img {
      width: 100%;
      height: 100%;
      /*position: absolute;*/
      /*left: 0;*/
      /*top: 0;*/
      z-index: 0;
    }
    .fade-enter-active {
      transition: all .3s ease;
    }
    .fade-enter {
      transform: scale(1.5);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/part1/Part1.vue